/*
 * Arroyo MFG — Collection card color swatches with hover image-swap
 * Theme: Local
 * Upload this file to: assets/product-card-swatches.js
 * Then load it once near the bottom of BOTH:
 *   sections/main-collection-product-grid.liquid
 *   sections/featured-collection.liquid
 * with:  <script src="{{ 'product-card-swatches.js' | asset_url }}" defer></script>
 *
 * Note: Local's card image is a real <img class="img"> (not a CSS background),
 * so we swap the img src/srcset. Event delegation on document keeps it working
 * after AJAX filter/sort re-renders the grid.
 */
function ciPrimaryImg(card){
  var fig = card.querySelector('.product-item__image-figure--primary');
  return fig ? (fig.querySelector('img.img') || fig.querySelector('img')) : null;
}
document.addEventListener('mouseover', function (e) {
  var sw = e.target.closest && e.target.closest('.product-item__swatch[data-swatch-image]');
  if (!sw) return;
  var card = sw.closest('[data-js-product-item]'); if (!card) return;
  var img = ciPrimaryImg(card); if (!img) return;
  if (img.getAttribute('data-orig-src') === null) {
    img.setAttribute('data-orig-src', img.getAttribute('src') || '');
    img.setAttribute('data-orig-srcset', img.getAttribute('srcset') || '');
  }
  card.classList.add('is-swatching');
  img.setAttribute('srcset', '');
  img.src = sw.getAttribute('data-swatch-image');
});
document.addEventListener('mouseout', function (e) {
  var wrap = e.target.closest && e.target.closest('[data-swatches]');
  if (!wrap) return;
  if (e.relatedTarget && wrap.contains(e.relatedTarget)) return;
  var card = wrap.closest('[data-js-product-item]'); if (!card) return;
  var img = ciPrimaryImg(card);
  if (img && img.getAttribute('data-orig-src') !== null) {
    img.src = img.getAttribute('data-orig-src');
    img.setAttribute('srcset', img.getAttribute('data-orig-srcset'));
  }
  card.classList.remove('is-swatching');
});
